import React from 'react';

import { Waypoint } from 'react-waypoint';

import cx from 'classnames';
import styles from './styles.module.scss';
import { localizedStrings } from "../../../localization/index"

class InfinteScroll extends React.Component {
  constructor(props){
    super(props);

    this._loadMoreItems = this._loadMoreItems.bind(this);

    this.localizedCommonLoading = localizedStrings.commons.loading;
    this.localizedCommonActions = localizedStrings.commons.actions;
    this.localizedCommons = localizedStrings.commons;
  }

  _loadMoreItems(){

    if(!this.props.loading){
      this.props.loadMore();
    }
  }

  _renderWaypoint(){
    if(!this.props.hasMore){
      return false;
    }

    return (
      <Waypoint bottomOffset='-100px' onEnter={this._loadMoreItems}>
        {this._renderLoading()}
      </Waypoint>
    )
  }

  _renderLoading() {
    if(!this.props.hasMore){
      return false;
    }

    if(this.props.loading){
      return <div className={cx(styles.loading,{
        [styles.dealRoomLoading] : this.props.isFromDealRoom
      })}>{this.localizedCommonLoading.more_items}...</div>
    }

    return <button className={styles.loadMore} onClick={this._loadMoreItems}>{this.localizedCommonActions.load_more_items}</button>
  }

  render(){
    return (
      <div className={styles.scroll}>
        {this.props.children}
        {this._renderWaypoint()}
      </div>
    );
  } 
}

export default InfinteScroll;